import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-template-counts',
  templateUrl: './template-counts.component.html',
  styleUrls: ['./template-counts.component.css']
})
export class TemplateCountsComponent implements OnInit {

  templateCountsList: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  userCred: any;
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false,
    isVerify: false,
    isApprove: false,
    isIssue: false,
    isAttach: false,
    isRemove: false
  }
  userLocations: any = [];
  locationList: any = [];
  locationFilterList: any = [];


  constructor(
    private toastr: ToastrService,
    private generic_service: GenericService,
    private router: Router) { }

  ngOnInit(): void {
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    // this.getAllObjectInfoByAllTemplateCounts()
    this.getAllLocation()
    localStorage.removeItem("template")
    this.actionControls = this.generic_service.checkActionControls(
      window.location.href.split('/').filter(Boolean).pop()?.toLowerCase() || ''
    );

    console.log(this.actionControls)
  }


  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page+1;
  }

  refreshAll(){
    this.page = 1
    this.first = 0
    this.templateCountsList = [],
    this.getAllObjectInfoByAllTemplateAndLocationsCounts()
  }


  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        this.locationList = res.response

        this.locationFilterList = (this.locationList?.filter((location: any) =>
          this.userCred?.locations?.includes(location.locationId)
        )) || [];
        console.log(this.locationFilterList)

        this.userLocations = this.locationFilterList.map((item: any) => item.zone);
        console.log(this.userLocations)
        this.getAllObjectInfoByAllTemplateAndLocationsCounts()
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllObjectInfoByAllTemplateAndLocationsCounts() {
    this.isLoading = true

    const body: any = {
      "template": "",
      "location": this.userLocations || []
    }
    console.log(body)

    this.generic_service.getAllObjectInfoByAllTemplateAndLocationsCounts(body).subscribe(
      (response: any) => {
        // this.templateCountsList = response.response.filter((list: any)=>{
        //   if(list.counts && list.counts != 0){
        //     return list
        //   }
        // })

        this.templateCountsList = response.response
        this.count = this.templateCountsList.length
        this.isLoading = false
      },
      (error: any) => {
        this.isLoading = false
        console.log(error)
      }
    )
  }


  templateSelect(list: any) {
    localStorage.setItem("template", JSON.stringify(list));
    this.router.navigate(['/admin/asset-list-filter']);
  }


  getAllObjectInfoByAllTemplateCounts(){
    this.isLoading = true
    this.generic_service.getAllObjectInfoByAllTemplateCounts().subscribe(
      (response:any)=>{
        this.templateCountsList = []
        this.templateCountsList = response.response
        this.count = response.response.length
        this.isLoading = false
      },
      (error:any)=>{
        this.isLoading = false
        console.log(error)
      }
    )
  }



}